import { FC } from 'react';
import { cn } from '@/lib/utils';
import { AdSlot } from './AdSlot';
import { AD_SLOT_CONFIGS } from './config';
import { useAdBreakpoint } from './useAdBreakpoint';
import type { AdSlotId } from './types';

const SLOT_WIDTH_CLASSNAMES: Partial<Record<AdSlotId, string>> = {
  'ad-inarticle-leaderboard': 'max-w-[728px]',
  'ad-sidebar-mpu': 'max-w-[300px]',
  'ad-section-league': 'max-w-[320px]',
  'ad-section-transfer': 'max-w-[320px]',
  'ad-sticky-leaderboard': 'max-w-[320px]',
};

interface ContentAdSlotProps {
  id: AdSlotId;
  className?: string;
  slotClassName?: string;
}

export const ContentAdSlot: FC<ContentAdSlotProps> = ({ id, className, slotClassName }) => {
  const config = AD_SLOT_CONFIGS[id];
  const breakpoint = useAdBreakpoint();

  if (!config.visibleOn.includes(breakpoint)) return null;

  return (
    <div
      className={cn('w-full px-[--padding-md] py-[--padding-xl] md:px-[--padding-7xl]', className)}
    >
      <AdSlot id={id} className={cn(SLOT_WIDTH_CLASSNAMES[id] ?? 'max-w-[970px]', slotClassName)} />
    </div>
  );
};
